import { render, staticRenderFns } from "./Endpoints.vue?vue&type=template&id=34bd8d88"
import script from "./Endpoints.vue?vue&type=script&lang=ts"
export * from "./Endpoints.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports